import React from 'react';

import {Group} from '@pb/kit-component-group';
import Loading from '@pb/kit-component-loading';

export const ContentLoader = () => (
    <Group alignItems="center" justify="center" style={{flexGrow: 1}}>
        <Loading fast={true}/>
    </Group>
);
